export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  trace_id?: string;
  [key: string]: unknown;
}

export class ApiError extends Error {
  readonly status: number;
  readonly problem: ProblemDetails | undefined;
  readonly traceId: string | undefined;

  constructor(status: number, message: string, problem?: ProblemDetails) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.problem = problem;
    this.traceId = problem?.trace_id;
  }
}

export function isBackendDown(err: unknown): boolean {
  if (!(err instanceof ApiError)) return false;
  return err.status === 404 || err.status === 501 || err.status >= 502;
}

export function isNotImplemented(err: unknown): boolean {
  return err instanceof ApiError && err.status === 501;
}

/** The sentence an error carries, or '' for a throw that is not an Error. */
export const errorDetail = (err: unknown): string => (err instanceof Error ? err.message : '');
